"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getBlockOffset(list, key) {
    for (let i = 0; i < list.value.length; i++) {
        const val = list.value[i];
        if ('type' in val && val.type === 'block-start' && val.blockKey === key) {
            return i;
        }
    }
    return null;
}
exports.default = getBlockOffset;
//# sourceMappingURL=getBlockOffset.js.map